import { SenderType } from "@/enums/ai";
import { useAiAgentsStore } from "@/stores/ai/agents";

import type { AiAgentSessionMessage } from "@/models/aiAgents";

export const handleAiAgentSessionsEvent = async (
  message: AiAgentSessionMessage
) => {
  if (message.sender_type !== SenderType.Agent) {
    return;
  }

  useAiAgentsStore().pushSessionMessage(message);
};
